import { Box } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { Text } from 'components';
import { BankCreditResponse, CreditOptionsResponse, CreditResponse } from 'types';

import CreditContractPaymentStructure from './contract-structure';
import CreditDetails from './details';
import CreditPaymentStructure from './structure';
import { useApprovedContract } from './use-approved-contract';

interface CreditPaymentProps {
  options: CreditOptionsResponse;
  credit: CreditResponse;
  bankCredit?: BankCreditResponse;
  readOnly?: boolean;
}

const CreditPayment = ({ options, credit, bankCredit, readOnly = false }: CreditPaymentProps) => {
  const { t } = useTranslation();
  const { contract, loading, updateContract } = useApprovedContract(credit.bankCreditRequestId);

  return (
    <Box p={'lg'}>
      <CreditDetails
        credit={credit}
        bankCredit={bankCredit}
        readOnly={readOnly}
        contract={contract}
        onContractChange={updateContract}
      />
      {readOnly && !contract && !loading && (
        <Text size={'sm'} c={'dimmed'} mt={'sm'}>
          {t('credit.payment.contractHint')}
        </Text>
      )}
      <Box mt={contract ? 'md' : 64}>
        {contract ? (
          <CreditContractPaymentStructure options={options} contract={contract} />
        ) : (
          <CreditPaymentStructure options={options} credit={credit} readOnly={readOnly} />
        )}
      </Box>
    </Box>
  );
};

export default CreditPayment;
